// modules
import React, { FC } from 'react';
import { LoadingBlock, View } from '@upstox/upstox-ui';
// styles
import * as css from './styles';

const PriceAlertsLoadingBody: FC = () => (
  <View css={css.container}>
    <View css={css.row}>
      <LoadingBlock height={12} width={45} />
      <View css={css.subRow}>
        <LoadingBlock height={12} width={45} />
        <LoadingBlock height={12} width={40} />
      </View>
    </View>
    <View css={css.row}>
      <LoadingBlock height={12} width={74} />
      <View css={css.subRow}>
        <LoadingBlock height={12} width={40} />
        <LoadingBlock height={12} width={40} />
      </View>
    </View>
    <View css={css.row}>
      <LoadingBlock height={12} width={74} />
      <View css={css.subRow}>
        <LoadingBlock height={12} width={40} />
        <LoadingBlock height={12} width={40} />
      </View>
    </View>
    <View css={css.row}>
      <LoadingBlock height={12} width={74} />
      <View css={css.subRow}>
        <LoadingBlock height={12} width={40} />
        <LoadingBlock height={12} width={40} />
      </View>
    </View>
  </View>
);

export default PriceAlertsLoadingBody;
